import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'
import Nprogress from 'nprogress';
import qs from 'qs'
Vue.use(Vuex)
const state = {
  sidebarDetails: [],
  generalConfigDetails: [],
  expressConfigDetails: [],
  miscellConfigDetails: [],
  tallyConfigDetails: [],
  dashConfigDetails: [],
  payConfigDetails: [],
  custPortURLConfigDetails: [],
  pmsSettingsDetails: [],
  franchiseSettingsDetails: [],
  adminWithAccessDetails: [],
  appRunTimeDetails:[],
  billingDetails: [],
  billingAddress: [],
  routerData: [],
  apiData: [],
  billingPeriodData: [],
  linkedInData: [],
  twitterData: [],
  facebookData: [],
  instagramData: [],
  googleplusData: [],
  invoicePrefixData: [],
  proformaInvoicePrefixData: [],
  paymentPrefixData: [],
  creditNotePrefixData: [],
  cafPrefixData: [],
  usernamePrefixData: [],
  circuitIdPrefixData: [],
  leadPrefixData: [],
  helpdeskPrefixData: [],
  approvalTaskData: [],
  payAsYouGoData: [],
  leadSettingsData: [],
  customRulesData: [],
  additionalFieldRulesData: [],
  adminSettingsData: [],
  profileSettingsData: [],
  paymentGatewayData: [],
  userFieldsData: [],
  additionalFieldsData: [],
  smsManagementData: [],
  smsManagementCloudData: [],
  tableHeaderConfigData: [],
  moveAccountsData: [],
  additionalFieldsData: [],
  workhrsData: [],
}

const mutations = {
  SET_GENERAL_DETAILS(state, settingsData) {
    state.generalConfigDetails = settingsData.message;
  },
  SET_TALLY_DETAILS(state, settingsData) {
    state.tallyConfigDetails = settingsData.message;
  },
  SET_DASHBOARD_DETAILS(state, settingsData) {
    state.dashConfigDetails = settingsData.message;
  },
  SET_PAYMENTCOLLECT_DETAILS(state, settingsData) {
    state.payConfigDetails = settingsData.message;
  },
  SET_CUSTPORTURL_DETAILS(state, settingsData) {
    state.custPortURLConfigDetails = settingsData.message;
  },
  SET_PMS_SETTINGS_DETAILS(state, settingsData) {
    state.pmsSettingsDetails = settingsData.message;
  },
  SET_FRANCHISE_SETTINGS_DATA(state, settingsData) {
    state.franchiseSettingsDetails = settingsData.message;
  },
  SET_ADMIN_WITH_ACCESS_DATA(state, settingsData) {
    state.adminWithAccessDetails = settingsData.message;
  },
  SET_APP_RUNTIME_DATA(state,settingData){
    state.appRunTimeDetails=settingData.message;
  },
  SET_SIDEBAR_DETAILS(state, settingsData) {
    state.sidebarDetails = settingsData.message;
  },
  SET_EXPRESS_DETAILS(state, settingsData) {
    state.expressConfigDetails = settingsData.message;
  },
  SET_MISCELLANEOUS_DETAILS(state, settingsData) {
    state.miscellConfigDetails = settingsData.message;
  },
  SET_BILLING_DETAILS(state, settingsData) {
    state.billingDetails = settingsData.message;
  },
  SET_BILLING_ADDRESS(state, settingsData) {
    state.billingAddress = settingsData.message;
  },
  SET_ROUTER_DATA(state, settingsData) {
    state.routerData = settingsData.message;
  },
  SET_API_DATA(state, settingsData) {
    state.apiData = settingsData.message;
  },
  SET_BILLING_PERIOD_DATA(state, settingsData) {
    state.billingPeriodData = settingsData.message;
  },
  SET_LINKEDIN_DATA(state, settingsData) {
    state.linkedInData = settingsData.message;
  },
  SET_TWITTER_DATA(state, settingsData) {
    state.twitterData = settingsData.message;
  },
  SET_FACEBOOK_DATA(state, settingsData) {
    state.facebookData = settingsData.message;
  },
  SET_INSTAGRAM_DATA(state, settingsData) {
    state.instagramData = settingsData.message;
  },
  SET_GOOGLEPLUS_DATA(state, settingsData) {
    state.googleplusData = settingsData.message;
  },
  SET_INVOICE_PREFIX_DATA(state, settingsData) {
    state.invoicePrefixData = settingsData.message;
  },
  SET_PROFORMA_INVOICE_PREFIX_DATA(state, settingsData) {
    state.proformaInvoicePrefixData = settingsData.message;
  },
  SET_PAYMENT_PREFIX_DATA(state, settingsData) {
    state.paymentPrefixData = settingsData.message;
  },
  SET_CREDIT_NOTE_PREFIX_DATA(state, settingsData) {
    state.creditNotePrefixData = settingsData.message;
  },
  SET_CAF_PREFIX_DATA(state, settingsData) {
    state.cafPrefixData = settingsData.message;
  },
  SET_USERNAME_PREFIX_DATA(state, settingsData) {
    state.usernamePrefixData = settingsData.message;
  },
  SET_CIRCUIT_ID_PREFIX_DATA(state, settingsData) {
    state.circuitIdPrefixData = settingsData.message;
  },
  SET_LEAD_PREFIX_DATA(state, settingsData) {
    state.leadPrefixData = settingsData.message;
  },
  SET_HELPDESK_PREFIX_DATA(state, settingsData) {
    state.helpdeskPrefixData = settingsData.message;
  },
  SET_TASK_SETTINGS_DATA(state, settingsData) {
    state.approvalTaskData = settingsData.message;
  },
  SET_PAYASYOUGO_DATA(state, settingsData) {
    state.payAsYouGoData = settingsData.message;
  },
  SET_LEAD_DATA(state, settingsData) {
    state.leadSettingsData = settingsData.message;
  },
  SET_CUSTOM_RULES_DATA(state, settingsData) {
    state.customRulesData = settingsData.message;
  },
  SET_ADMIN_SETTINGS_DATA(state, settingsData) {
    state.adminSettingsData = settingsData.message;
  },
  SET_PROFILE_SETTINGS_DATA(state, settingsData) {
    state.profileSettingsData = settingsData.message;
  },
  SET_PAYMENT_GATEWAY_DATA(state, settingsData) {
    state.paymentGatewayData = settingsData.message;
  },
  SET_USER_FIELDS_DATA(state, settingsData) {
    state.userFieldsData = settingsData.message;
  },
  SET_ADDITIONAL_FIELDS_DATA(state, settingsData) {
    state.additionalFieldsData = settingsData.message;
    state.additionalFieldRulesData = settingsData.message.additionalFieldRules;
  },
  SET_SMS_MANAGEMENT_DATA(state, settingsData) {
    state.smsManagementData = settingsData.message;
  },
  SET_SMS_MANAGEMENT_CLOUD_DATA(state, settingsData) {
    state.smsManagementCloudData = settingsData.message;
  },
  SET_TABLE_HEADER_DATA(state, settingsData) {
    state.tableHeaderConfigData = settingsData.message;
  },
  SET_MOVE_ZONE_DATA(state, settingsData) {
    state.moveAccountsData = settingsData.message;
  },
  DELETE_VENDOR_LIST(state, settingsData) {
    if (settingsData.type == 'express') {
      if (state.expressConfigDetails.editData.vendorTablesData != undefined && state.expressConfigDetails.editData.vendorTablesData.length != 0) {
        var vendor = state.expressConfigDetails.editData.vendorTablesData;
        for (var i = 0; i < vendor.length; i++) {
          var index = vendor.findIndex(vendor => vendor.VendorAttribute.id == settingsData.id);
          if (index != '-1') {
            state.expressConfigDetails.editData.vendorTablesData.splice(index, 1);
          }
        }
      }
    } else if (settingsData.type == 'billing') {
      if (state.billingDetails.editData.vendorTablesData != undefined && state.billingDetails.editData.vendorTablesData.length != 0) {
        var vendor = state.billingDetails.editData.vendorTablesData;
        for (var i = 0; i < vendor.length; i++) {
          var index = vendor.findIndex(vendor => vendor.VendorAttribute.id == settingsData.id);
          if (index != '-1') {
            state.billingDetails.editData.vendorTablesData.splice(index, 1);
          }
        }
      }
    }
  },
  SET_CHECKBOX_VALUE(state, settingsData) {
    if (settingsData.type == 'miscellaneous') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.miscellConfigDetails, 'subAccountsCanNotChangeMiscConfiguration', 'Yes');
      } else {
        Vue.set(state.miscellConfigDetails, 'subAccountsCanNotChangeMiscConfiguration', 'No');
      }
    } else if (settingsData.type == 'tally') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.tallyConfigDetails, 'subAccountsCanNotChangeTallyInformation', 'Yes');
      } else {
        Vue.set(state.tallyConfigDetails, 'subAccountsCanNotChangeTallyInformation', 'No');
      }
    } else if (settingsData.type == 'dashboard') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.dashConfigDetails, 'subAccountsCanNotChangeDashboard', 'Yes');
      } else {
        Vue.set(state.dashConfigDetails, 'subAccountsCanNotChangeDashboard', 'No');
      }
    } else if (settingsData.type == 'paymentcollect') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.payConfigDetails, 'subAccountsCanNotChangePaymentCollection', 'Yes');
      } else {
        Vue.set(state.payConfigDetails, 'subAccountsCanNotChangePaymentCollection', 'No');
      }
    } else if (settingsData.type == 'billing') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.billingDetails, 'subAccountsCanNotChangeBillingSettings', 'Yes');
      } else {
        Vue.set(state.billingDetails, 'subAccountsCanNotChangeBillingSettings', 'No');
      }
    } else if (settingsData.type == 'billing_addr') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.billingAddress, 'subAccountsCanNotChangeBillingAddress', 'Yes');
      } else {
        Vue.set(state.billingAddress, 'subAccountsCanNotChangeBillingAddress', 'No');
      }
    } else if (settingsData.type == 'payAsYouGo') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.payAsYouGoData, 'subAccountsCanNotChangePayAsYouGoSettings', 'Yes');
      } else {
        Vue.set(state.payAsYouGoData, 'subAccountsCanNotChangePayAsYouGoSettings', 'No');
      }
    } else if (settingsData.type == 'lead') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.leadSettingsData, 'subAccountsCanNotChangeLeadSettings', 'Yes');
      } else {
        Vue.set(state.leadSettingsData, 'subAccountsCanNotChangeLeadSettings', 'No');
      }
    } else if (settingsData.type == 'userFields') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.userFieldsData, 'subAccountsCanNotChangeUserFieldsValues', 'Yes');
      } else {
        Vue.set(state.userFieldsData, 'subAccountsCanNotChangeUserFieldsValues', 'No');
      }
    } else if (settingsData.type == 'additionalFields') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.additionalFieldsData, 'subAccountsCanNotChangeAdditionalFieldsValues', 'Yes');
      } else {
        Vue.set(state.additionalFieldsData, 'subAccountsCanNotChangeAdditionalFieldsValues', 'No');
      }
    } else if (settingsData.type == 'tableHeader') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.tableHeaderConfigData, 'subAccountsCanNotChangeTableHeaderConfiguration', 'Yes');
      } else {
        Vue.set(state.tableHeaderConfigData, 'subAccountsCanNotChangeTableHeaderConfiguration', 'No');
      }
    } else if (settingsData.type == 'custom_rules') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.billingAddress, 'subAccountsCanNotChangeCustomRules', 'Yes');
      } else {
        Vue.set(state.billingAddress, 'subAccountsCanNotChangeCustomRules', 'No');
      }
    }
  },
  DELETE_BILLING_PERIOD(state, data) {
    var index = "";
    if (Object.keys(state.billingPeriodData).length != 0 && Object.keys(state.billingPeriodData.periods).length != 0) {
      for (var i = 0; i < state.billingPeriodData.periods.length; i++) {
        if (state.billingPeriodData.periods[i].id == data.id) {
          index = i;
        }
      }
      state.billingPeriodData.periods.splice(index, 1)
    }
  },
  ADD_BILLING_PERIOD(state, data) {
    if (Object.keys(state.billingPeriodData).length != 0) {
      state.billingPeriodData.periods.push(data);
    }
  },
  UPDATE_INVOICE_PREFIX(state, data) {
    Vue.set(state.invoicePrefixData, 'prefixIn', data);
  },
  UPDATE_PROFORMA_INVOICE_PREFIX(state, data) {
    Vue.set(state.proformaInvoicePrefixData, 'prefixIn', data);
  },
  UPDATE_PAYMENT_PREFIX(state, data) {
    Vue.set(state.paymentPrefixData, 'prefixIn', data);
  },
  UPDATE_CREDIT_NOTE_PREFIX(state, data) {
    Vue.set(state.creditNotePrefixData, 'prefixIn', data);
  },
  UPDATE_CAF_PREFIX(state, data) {
    Vue.set(state.cafPrefixData, 'prefixIn', data);
  },
  UPDATE_CIRCUIT_ID_PREFIX(state, data) {
    Vue.set(state.circuitIdPrefixData, 'prefixIn', data);
  },
  UPDATE_LEAD_PREFIX(state, data) {
    Vue.set(state.leadPrefixData, 'prefixIn', data);
  },
  UPDATE_HELPDESK_PREFIX(state, data) {
    Vue.set(state.helpdeskPrefixData, 'prefixIn', data);
  },
  UPDATE_INVOICE_NUMBER(state, data) {
    Vue.set(state.invoicePrefixData, 'selectedInvoiceNumber', data);
  },
  UPDATE_PROFORMA_INVOICE_NUMBER(state, data) {
    Vue.set(state.proformaInvoicePrefixData, 'selectedProformaNumber', data);
  },
  UPDATE_PAYMENT_NUMBER(state, data) {
    Vue.set(state.paymentPrefixData, 'selectedPaymentNumber', data);
  },
  UPDATE_CREDIT_NOTE_NUMBER(state, data) {
    Vue.set(state.creditNotePrefixData, 'selectedPaymentNumber', data);
  },
  UPDATE_CIRCUIT_ID_NUMBER(state, data) {
    Vue.set(state.circuitIdPrefixData, 'selectedCircuitNumber', data);
  },
  UPDATE_LEAD_NUMBER(state, data) {
    Vue.set(state.leadPrefixData, 'selectedLeadNumber', data);
  },
  UPDATE_CAF_NUMBER(state, data) {
    Vue.set(state.cafPrefixData, 'selectedCafNumber', data);
  },
  UPDATE_CAF_DATA(state, data) {
    Vue.set(state.cafPrefixData, 'automaticCafGeneration', data);
  },
  UPDATE_ROUTER_DATA(state, data) {
    Vue.set(state.routerData, 'subAccountMergeExtraArr', data);
  },
  UPDATE_PROFILE_SETTINGS_DATA(state, data) {
    Vue.set(state.profileSettingsData, 'accountsArr', data);
  },
  UPDATE_SMS_LIMIT(state, data) {
    if (Object.keys(state.smsManagementData).length != 0) {
      for (var i = 0; i < state.smsManagementData.smsDetails.length; i++) {
        if (state.smsManagementData.smsDetails[i].accountId == data.account) {
          Vue.set(state.smsManagementData.smsDetails[i], 'totalSmsCount', data.smsLimit);
          Vue.set(state.smsManagementData.smsDetails[i], 'unlimitedSMS', data.unlimitedSMS);
        }
      }
    }
  },
  UPDATE_ADDITIONAL_FIELDS_DATA(state, settingsData) {
    Vue.set(state.additionalFieldsData, 'metaFieldNameValues', settingsData);
  },
  ADD_CUSTOM_RULES(state, data) {
    if (Object.keys(state.customRulesData).length != 0) {
      state.customRulesData.customRules.push(data);
    }
  },
  EDIT_CUSTOM_RULES(state, data) {
    var index = "";
    if (Object.keys(state.customRulesData).length != 0 && Object.keys(state.customRulesData.customRules).length != 0) {
      for (var i = 0; i < state.customRulesData.customRules.length; i++) {
        if (state.customRulesData.customRules[i].RequestAccessRule.id == data.RequestAccessRule.id) {
          index = i;
        }
      }
      Vue.set(state.customRulesData.customRules, index, data);
    }
  },
  DELETE_CUSTOM_RULES(state, data) {
    var index = "";
    if (Object.keys(state.customRulesData).length != 0 && Object.keys(state.customRulesData.customRules).length != 0) {
      for (var i = 0; i < state.customRulesData.customRules.length; i++) {
        if (state.customRulesData.customRules[i].RequestAccessRule.id == data.id) {
          index = i;
        }
      }
      state.customRulesData.customRules.splice(index, 1)
    }
  },
  ADD_ADDITIONAL_FIELD_RULES(state, data) {
    if (Object.keys(state.additionalFieldRulesData).length != 0) {
      state.additionalFieldRulesData.push(data);
    }
  },
  EDIT_ADDITIONAL_FIELD_RULES(state, data) {
    var index = "";
    if (Object.keys(state.additionalFieldRulesData).length != 0 && Object.keys(state.additionalFieldRulesData).length != 0) {
      for (var i = 0; i < state.additionalFieldRulesData.length; i++) {
        if (state.additionalFieldRulesData[i].RequestAccessRule.id == data.RequestAccessRule.id) {
          index = i;
        }
      }
      Vue.set(state.additionalFieldRulesData, index, data);
    }
  },
  DELETE_ADDITIONAL_FIELD_RULES(state, data) {
    var index = "";
    if (Object.keys(state.additionalFieldRulesData).length != 0 && Object.keys(state.additionalFieldRulesData).length != 0) {
      for (var i = 0; i < state.additionalFieldRulesData.length; i++) {
        if (state.additionalFieldRulesData[i].RequestAccessRule.id == data.id) {
          index = i;
        }
      }
      state.additionalFieldRulesData.splice(index, 1)
    }
  },
  UPDATE_HELPDESK_NUMBER(state, data) {
    Vue.set(state.helpdeskPrefixData, 'selectedHelpDeskNumber', data);
  },
  SET_FAILURE(state, error) {
    Nprogress.done();
    Vue.notify({
      group: 'foo',
      type: 'error',
      text: error
    });
  },
  SET_SUCCESS(state, success) {
    Nprogress.done();
    Vue.notify({
      group: 'foo',
      type: 'success',
      text: success
    });
  },

  CLEAR_SETTINGS_STATE(state) {
    state.generalConfigDetails = [];
    state.expressConfigDetails = [];
    state.miscellConfigDetails = [];
    state.tallyConfigDetails = [];
    state.dashConfigDetails = [];
    state.payConfigDetails = [];
    state.custPortURLConfigDetails = [];
    state.pmsSettingsDetails = [];
    state.franchiseSettingsDetails = [];
    state.adminWithAccessDetails = [];
    state.appRunTimeDetails=[];
    state.billingDetails = [];
    state.billingAddress = [];
    state.routerData = [];
    state.apiData = [];
    state.billingPeriodData = [];
    state.linkedInData = [];
    state.twitterData = [];
    state.facebookData = [];
    state.instagramData = [];
    state.googleplusData = [];
    state.invoicePrefixData = [];
    state.proformaInvoicePrefixData = [];
    state.paymentPrefixData = [];
    state.creditNotePrefixData = [];
    state.usernamePrefixData = [];
    state.circuitIdPrefixData = [];
    state.leadPrefixData = [];
    state.helpdeskPrefixData = [];
    state.approvalTaskData = [];
    state.payAsYouGoData = [];
    state.leadSettingsData = [];
    state.customRulesData = [];
    state.additionalFieldRulesData = [];
    state.adminSettingsData = [];
    state.profileSettingsData = [];
    state.paymentGatewayData = [];
    state.userFieldsData = [];
    state.additionalFieldsData = [];
    state.smsManagementData = [];
    state.smsManagementCloudData = [];
    state.tableHeaderConfigData = [];
    state.moveAccountsData = [];
    state.workhrsData = [];
  },
  SET_WORK_DETAILS(state, settingsData) {
    state.workhrsData = settingsData.response;
  },
}

const actions = {
  fetchSidebarDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/settings_sidebar")
      .then(response => {
        Nprogress.done()
        commit('SET_SIDEBAR_DETAILS', response.data)
      })
      .catch(error => console.log(error))
  },

  fetchGeneralDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/index/true")
      .then(response => {
        Nprogress.done()
        commit('SET_GENERAL_DETAILS', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchExpressDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/express_configuration/true")
      .then(response => {
        Nprogress.done()
        commit('SET_EXPRESS_DETAILS', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchMiscellaneousDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/miscellaneous_configuration/true")
      .then(response => {
        Nprogress.done()
        commit('SET_MISCELLANEOUS_DETAILS', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchTallyDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/tally_informations/true")
      .then(response => {
        Nprogress.done()
        commit('SET_TALLY_DETAILS', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchDashboardDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/dashboard_configuration/true")
      .then(response => {
        Nprogress.done()
        commit('SET_DASHBOARD_DETAILS', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchPaymentCollectDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/payment_collection_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_PAYMENTCOLLECT_DETAILS', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchCustPortURLDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/customer_portal_url/true")
      .then(response => {
        Nprogress.done()
        commit('SET_CUSTPORTURL_DETAILS', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchPMSSettingsDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/pms_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_PMS_SETTINGS_DETAILS', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchBillingDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/billing_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_BILLING_DETAILS', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchBillingAddress({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/billing_address/true")
      .then(response => {
        Nprogress.done()
        commit('SET_BILLING_ADDRESS', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchRouterData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/router_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_ROUTER_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchApiDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/apis/true")
      .then(response => {
        Nprogress.done()
        commit('SET_API_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchBillingPeriodData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/billing_period/true")
      .then(response => {
        Nprogress.done()
        commit('SET_BILLING_PERIOD_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchfranchiseSettingsData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/franchise_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_FRANCHISE_SETTINGS_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchAdminWithAccessData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/admins_with_access/true")
      .then(response => {
        Nprogress.done()
        commit('SET_ADMIN_WITH_ACCESS_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },
  fetchAppRunTimeData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/app_runtime/true")
      .then(response => {
        Nprogress.done()
        commit('SET_APP_RUNTIME_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },
  fetchLinkedInData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/linkedin_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_LINKEDIN_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchTwitterData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/twitter_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_TWITTER_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchFacebookData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/facebook_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_FACEBOOK_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchInstgaramData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/instagram_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_INSTAGRAM_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchGoogleData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/google_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_GOOGLEPLUS_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchinvoicePrefixData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/invoice_prefix/true")
      .then(response => {
        Nprogress.done()
        commit('SET_INVOICE_PREFIX_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchProformaInvoiceData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/proforma_invoice_prefix/true")
      .then(response => {
        Nprogress.done()
        commit('SET_PROFORMA_INVOICE_PREFIX_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchPaymentPrefixData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/payment_prefix/true")
      .then(response => {
        Nprogress.done()
        commit('SET_PAYMENT_PREFIX_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchCreditNotePrefixData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/credit_note_prefix/true")
      .then(response => {
        Nprogress.done()
        commit('SET_CREDIT_NOTE_PREFIX_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchCafPrefixData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/caf_prefix/true")
      .then(response => {
        Nprogress.done()
        commit('SET_CAF_PREFIX_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchUsernamePrefixData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/username_prefix/true")
      .then(response => {
        Nprogress.done()
        commit('SET_USERNAME_PREFIX_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchCircuitIdPrefixData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/circuitid_prefix/true")
      .then(response => {
        Nprogress.done()
        commit('SET_CIRCUIT_ID_PREFIX_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchLeadPrefixData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/lead_prefix/true")
      .then(response => {
        Nprogress.done()
        commit('SET_LEAD_PREFIX_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchHelpdeskPrefixData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/helpdesk_prefix/true")
      .then(response => {
        Nprogress.done()
        commit('SET_HELPDESK_PREFIX_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchapprovalTasks({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/task_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_TASK_SETTINGS_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchPayAsYouGoDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/payasyougo_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_PAYASYOUGO_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchLeadSettingDetails({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/lead_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_LEAD_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchCustomRulesData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/custom_rules/true")
      .then(response => {
        Nprogress.done()
        commit('SET_CUSTOM_RULES_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchAdminUserGroups({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/admin_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_ADMIN_SETTINGS_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchProfileSettings({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/profile_settings/true")
      .then(response => {
        Nprogress.done()
        commit('SET_PROFILE_SETTINGS_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchPaymentGatewaySettings({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/tag_payment_gateway/true")
      .then(response => {
        Nprogress.done()
        commit('SET_PAYMENT_GATEWAY_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },
  fetchPaymentGatewayZone({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/dashboard/zone_tag_payment_gateway/" + authData + "/true")
      .then(response => {
        Nprogress.done()
        commit('SET_PAYMENT_GATEWAY_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchUserFieldSettings({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/user_mandatory_fields/true")
      .then(response => {
        Nprogress.done()
        commit('SET_USER_FIELDS_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchAdditionalFieldSettings({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/additional_fields/true")
      .then(response => {
        Nprogress.done()
        commit('SET_ADDITIONAL_FIELDS_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchsmsManagementData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/sms_management/true")
      .then(response => {
        Nprogress.done()
        commit('SET_SMS_MANAGEMENT_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchsmsManagementCloudData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/sms_managements/true")
      .then(response => {
        Nprogress.done()
        commit('SET_SMS_MANAGEMENT_CLOUD_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchTableHeaderConfig({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/table_header_configuration/true")
      .then(response => {
        Nprogress.done()
        commit('SET_TABLE_HEADER_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  fetchmoveAccountsData({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/move_accounts/true")
      .then(response => {
        Nprogress.done()
        commit('SET_MOVE_ZONE_DATA', response.data)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },

  generalConfigurationSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/submit_form', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  expressConfigurationSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/express_configuration_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  miscellaneousConfigurationSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/miscellaneous_configuration_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  tallyConfigurationSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/tally_informations_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  dashboardConfigurationSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/dashboard_configuration_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  paymentcollectConfigurationSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/payment_collection_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  customerPortalURLSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/customer_portal_url_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  pmsSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/pms_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  franchiseSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/franchise_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  billingSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/billing_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  billingAddressSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/submit_billing_address_form', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  linkedInSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/linkedin_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.settingsServerSuccess);
        })
        .catch(error => console.log(error));
    });
  },

  twitterSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/twitter_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.settingsServerSuccess);
        })
        .catch(error => console.log(error));
    });
  },

  facebookSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/facebook_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.settingsServerSuccess);
        })
        .catch(error => console.log(error));
    });
  },

  instaSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/instagram_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.settingsServerSuccess);
        })
        .catch(error => console.log(error));
    });
  },

  googleSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/google_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.settingsServerSuccess);
        })
        .catch(error => console.log(error));
    });
  },

  userFieldSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/user_registration_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  taskSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/task_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  leadSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/lead_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  paymentGatewaySettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/tag_payment_gateway_settings_submit/true', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  moveAccountsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/move_accounts_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createPrefixforInvoice({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/invoice_prefix_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_INVOICE_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createPrefixforProformaInvoice({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/proforma_invoice_prefix_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_PROFORMA_INVOICE_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createPrefixforPayment({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/payment_prefix_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_PAYMENT_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createPrefixforCreditNote({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/credit_note_prefix_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_CREDIT_NOTE_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createPrefixforCaf({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/caf_prefix_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_CAF_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createPrefixforCircuit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/curcuit_id_prefix_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_CIRCUIT_ID_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createPrefixforLead({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/lead_prefix_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_LEAD_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createPrefixforHelpdesk({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/helpdesk_prefix_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_HELPDESK_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createInvoiceNumber({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/invoice_prefix_number_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.invoiceNumber;
          commit('UPDATE_INVOICE_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createProformaInvoiceNumber({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/proforma_prefix_number_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.invoiceNumber;
          commit('UPDATE_PROFORMA_INVOICE_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createPaymentNumber({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/payment_prefix_number_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.invoiceNumber;
          commit('UPDATE_PAYMENT_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createCreditNoteNumber({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/credit_note_prefix_number_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.invoiceNumber;
          commit('UPDATE_CREDIT_NOTE_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createCircuitIdNumber({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/circuit_prefix_number_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.circuitNumber;
          commit('UPDATE_CIRCUIT_ID_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createLeadNumber({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/lead_prefix_number_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.leadNumber;
          commit('UPDATE_LEAD_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createHelpdeskNumber({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/helpdesk_prefix_number_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.helpdeskNumber;
          commit('UPDATE_HELPDESK_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  createCafNumber({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/caf_prefix_number_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.cafNumber;
          commit('UPDATE_CAF_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deletePrefixforInvoice({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_invoice_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_INVOICE_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deletePrefixforProformaInvoice({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_proforma_invoice_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_PROFORMA_INVOICE_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deletePrefixforPayment({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_payment_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_PAYMENT_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deletePrefixforCreditNote({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_credit_note_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_CREDIT_NOTE_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deletePrefixforCaf({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_caf_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_CAF_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deletePrefixforCircuit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_circuit_id_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_CIRCUIT_ID_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deletePrefixforLead({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_lead_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_LEAD_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deletePrefixforHelpdesk({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_helpdesk_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.prefixList;
          commit('UPDATE_HELPDESK_PREFIX', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deleteNumforInvoice({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_invoice_number_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.invoiceNumber;
          commit('UPDATE_INVOICE_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deleteNumforProformaInvoice({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_Proforma_number_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.proformaNumber;
          commit('UPDATE_PROFORMA_INVOICE_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deleteNumforPayment({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_payment_number_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.paymentNumber;
          commit('UPDATE_PAYMENT_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deleteNumforCreditNote({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_credit_note_number_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.paymentNumber;
          commit('UPDATE_CREDIT_NOTE_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deleteNumforCircuit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_circuit_number_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.circuitNumber;
          commit('UPDATE_CIRCUIT_ID_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deleteNumforLead({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_lead_number_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.leadNumber;
          commit('UPDATE_LEAD_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deleteNumforHelpdesk({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_helpdesk_number_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.helpdeskNumber;
          commit('UPDATE_HELPDESK_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deleteNumforCaf({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_caf_number_prefix', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.cafNumber;
          commit('UPDATE_CAF_NUMBER', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  updateAutoCaf({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/caf_auto_generate', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = response.data.automaticCafGeneration;
          commit('UPDATE_CAF_DATA', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deleteCustomRuleSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_custom_rule', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            id: postData.fieldId,
          }
          commit('DELETE_CUSTOM_RULES', successData);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  invoicePrefixSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/submit_invoice_prefix_form', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  paymentPrefixSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/submit_payment_prefix_form', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  creditNotePrefixSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/submit_credit_note_prefix_form', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  circuitPrefixSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/submit_circuit_id_prefix_form', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  leadPrefixSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/submit_lead_prefix_form', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  helpdeskPrefixSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/submit_helpdesk_prefix_form', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  usernamePrefixSUbmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/username_prefix_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  cafPrefixSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/submit_caf_prefix_form', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  payAsYouGoSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/payasyougo_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  zoneConfigSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/save_vendor_config', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deleteVendorSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_vendor_config', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            id: response.data.vendorId,
            type: postData.type
          }
          commit('DELETE_VENDOR_LIST', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  addBillingPeriodSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_billing_period/true', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            id: response.data.periodAdded.id,
            entityId: response.data.periodAdded.account_id,
            periodUnitId: response.data.periodAdded.unit_id,
            value: response.data.periodAdded.value,
          }
          commit('ADD_BILLING_PERIOD', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deleteBillingPeriodSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_billing_period/true', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            id: postData.periodId,
          }
          commit('DELETE_BILLING_PERIOD', successData);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  addNewTaxSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/franchise_management/add_tax_field/true', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  deleteAdditionalTaxesSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/franchise_management/delete_tax_field/true', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'Success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  addCustomRuleSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_edit_custom_rules', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (postData.fieldId == "") {
            commit('ADD_CUSTOM_RULES', response.data.customRule);
            resolve(response.data.genericBody);
          } else {
            commit('EDIT_CUSTOM_RULES', response.data.customRule);
            resolve(response.data.genericBody1);
          }
        })
        .catch(error => console.log(error));
    });
  },

  routerSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/router_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_ROUTER_DATA', response.data.subAccountMergeExtraArr);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  adminSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/admin_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  profileSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/profile_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            var res = {};
            if (response.data.status == 'profile name error') {
              res.profileGroups = response.data.message;
              res.type = 'profileNameError'
            } else {
              res.profileGroups = response.data.message;
              res.type = 'error'
            }
            reject(res);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },
  editAdditionalFieldsData({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/edit_meta_fields', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteMetaFieldOption({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/del_metaField_option', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_ADDITIONAL_FIELDS_DATA', response.data.metaFieldNameValues);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  addMetaFieldOption({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_metaField_option', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_ADDITIONAL_FIELDS_DATA', response.data.metaFieldNameValues);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  moveMetaFieldUp({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/move_meta_field_up', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_ADDITIONAL_FIELDS_DATA', response.data.metaFieldNameValues);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  moveMetaFieldDown({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/move_meta_field_down', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_ADDITIONAL_FIELDS_DATA', response.data.metaFieldNameValues);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  deleteMetaFieldSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/del_meta_field', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_ADDITIONAL_FIELDS_DATA', response.data.metaFieldNameValues);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  createMetaFieldFormSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/create_meta_field', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_ADDITIONAL_FIELDS_DATA', response.data.metaFieldNameValues);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  addPackageSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/save_package_deactivate', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_PROFILE_SETTINGS_DATA', response.data.accountsArr);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  removePackageSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_package_deactivate', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_PROFILE_SETTINGS_DATA', response.data.accountsArr);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  addSmsLimitSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/sms_management_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_SMS_LIMIT', response.data.addedSmsDetail);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  smsManagementCloudSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/sms_configuration_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  tableHeaderConfigsubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/submit_table_header_configuration_form', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },



  saveSubAccountPermissionSettings({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/save_sub_accounts_cannot_change_settings', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('SET_CHECKBOX_VALUE', postData);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  tableConfigSetDefaults({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/reset_table_headers', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  tableConfigSetDefaultsToSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_default_toall_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  addMiscellaneousToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_allto_miscellaneousConfiguration_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addTallyToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_tally_information_to_subAcc', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addDashboardToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_dashbord_configuration_toall_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addPaymentcollectToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_payment_collection_to_subAcc', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addPayAsYouGoToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_allto_payasyougo_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addBillingToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_allto_billingSettings_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addBillingAddrToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_billing_address_to_subAcc', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  addCustomRulesToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_custom_rules_to_all_accounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  addLeadSettingsToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_allto_lead_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addUserSettingsToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_all_users_save_fields', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addAdditionalSettingsToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_additional_fields_subacc', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addTableConfigToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_tables_toall_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  addPrefixConfigToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_prefix_toall_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  addAdditionalFieldRuleSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_edit_additional_field_rules', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (postData.fieldId == "") {
            commit('ADD_ADDITIONAL_FIELD_RULES', response.data.additionalFieldRule);
            resolve(response.data.genericBody);
          } else {
            commit('EDIT_ADDITIONAL_FIELD_RULES', response.data.additionalFieldRule);
            resolve(response.data.genericBody1);
          }
        })
        .catch(error => console.log(error));
    });
  },
  deleteAdditionalFieldRuleSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/delete_additional_field_rule', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            id: postData.fieldId,
          }
          commit('DELETE_ADDITIONAL_FIELD_RULES', successData);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  clearSettingsState({
    commit,
    dispatch
  }) {
    commit('CLEAR_SETTINGS_STATE')
  },
  errorMessage({
    commit,
    dispatch
  }, error) {
    commit('SET_FAILURE', error);
  },
  successMessage({
    commit,
    dispatch
  }, error) {
    commit('SET_SUCCESS', error);
  },
  fetchWorkHrs({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/settings/enable_working_hours/" + authData.action + "/" + authData.adminId)
      .then(response => {
        Nprogress.done()
        commit('SET_WORK_DETAILS', response.data)
      })
      .catch(error => console.log(error))
  },
  saveWrkData({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/enable_working_hours/' + postData.action + "/" + postData.adminId, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  defaultPackageSettingsSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/default_package_settings_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            var res = {};
            res.profileGroups = response.data.message;
            res.type = 'error'
            reject(res);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },
  addDefaultPackageSettingsToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/add_defalt_package_settings_to_all_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  additionalFieldMappingValueSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/additional_field_mapping_value_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
}

const getters = {
  sidebarDetailsGetter: state => {
    return state.sidebarDetails;
  },
  generalConfigGetter: state => {
    return state.generalConfigDetails;
  },
  tallyConfigGetter: state => {
    return state.tallyConfigDetails;
  },
  expressConfigGetter: state => {
    return state.expressConfigDetails;
  },
  miscellaneousConfigGetter: state => {
    return state.miscellConfigDetails;
  },
  dashboardConfigGetter: state => {
    return state.dashConfigDetails;
  },
  paymentConfigGetter: state => {
    return state.payConfigDetails;
  },
  custPortURLConfigGetter: state => {
    return state.custPortURLConfigDetails;
  },
  pmsSettingsGetter: state => {
    return state.pmsSettingsDetails;
  },
  franchiseSettingsGetter: state => {
    return state.franchiseSettingsDetails;
  },
  adminWithAccessGetter: state => {
    return state.adminWithAccessDetails;
  },
  appRunTimeGetter: state => {
    return state.appRunTimeDetails;
  },
  billingSettingsGetter: state => {
    return state.billingDetails;
  },
  billingAddressGetter: state => {
    return state.billingAddress;
  },
  routerSettingsGetter: state => {
    return state.routerData;
  },
  apiDataGetter: state => {
    return state.apiData;
  },
  billingPeriodGetter: state => {
    return state.billingPeriodData;
  },
  linkedInGetter: state => {
    return state.linkedInData;
  },
  twitterDataGetter: state => {
    return state.twitterData;
  },
  facebookDataGetter: state => {
    return state.facebookData;
  },
  instagramDataGetter: state => {
    return state.instagramData;
  },
  googlePlusGetter: state => {
    return state.googleplusData;
  },
  invoicePrefixGetter: state => {
    return state.invoicePrefixData;
  },
  proformaInvoiceGetter: state => {
    return state.proformaInvoicePrefixData;
  },
  paymentPrefixGetter: state => {
    return state.paymentPrefixData;
  },
  creditNotePrefixGetter: state => {
    return state.creditNotePrefixData;
  },
  cafPrefixGetter: state => {
    return state.cafPrefixData;
  },
  usernamePrefixGetter: state => {
    return state.usernamePrefixData;
  },
  circuitIdPrefixGetter: state => {
    return state.circuitIdPrefixData;
  },
  leadPrefixGetter: state => {
    return state.leadPrefixData;
  },
  helpdeskPrefixGetter: state => {
    return state.helpdeskPrefixData;
  },
  approvalTasksGetter: state => {
    return state.approvalTaskData;
  },
  payAsYouGoGetter: state => {
    return state.payAsYouGoData;
  },
  leadSettingsGetter: state => {
    return state.leadSettingsData;
  },
  customRulesGetter: state => {
    return state.customRulesData;
  },
  adminSettingsGetter: state => {
    return state.adminSettingsData;
  },
  profileSettingsGetter: state => {
    return state.profileSettingsData;
  },
  paymentGatewaySettingsGetter: state => {
    return state.paymentGatewayData;
  },
  userFieldSettingsGetter: state => {
    return state.userFieldsData;
  },
  additionalFieldsGetter: state => {
    return state.additionalFieldsData;
  },
  smsManagementGetter: state => {
    return state.smsManagementData;
  },
  cloudSmsManagementGetter: state => {
    return state.smsManagementCloudData;
  },
  tableHeaderConfigGetter: state => {
    return state.tableHeaderConfigData;
  },
  moveAccountsGetter: state => {
    return state.moveAccountsData;
  },
  additionalFieldRulesGetter: state => {
    return state.additionalFieldRulesData;
  },
  enableWorkingHrsGetters: state => {
    return state.workhrsData;
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}
